import React from "react";
import { Camera, X, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ReceitaFotos({
  fotos, pendingFiles, uploading, isEditing, handleFotoUpload, handleFotoRemove, removePendingFile,
}) {
  return (
    <div>
      <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-200 pb-2 mb-4">Fotos da Receita / OS</h3>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <label className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 border border-slate-200 rounded-lg cursor-pointer hover:bg-slate-200 transition-colors text-sm font-medium text-slate-700"
            data-testid="btn-upload-foto">
            {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Camera className="w-4 h-4" />}
            {uploading ? "Enviando..." : "Anexar Foto"}
            <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden"
              onChange={handleFotoUpload} disabled={uploading} data-testid="input-foto-upload" />
          </label>
          <span className="text-xs text-slate-400">JPG, PNG ou WEBP</span>
          {!isEditing && pendingFiles.length > 0 && (
            <span className="text-xs text-blue-600 font-medium">{pendingFiles.length} foto(s) selecionada(s)</span>
          )}
        </div>

        {fotos.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-testid="fotos-grid">
            {fotos.map((url, i) => (
              <div key={url} className="relative group rounded-lg overflow-hidden border border-slate-200">
                <img src={url.startsWith("http") ? url : `${BACKEND_URL}${url}`} alt={`Foto ${i + 1}`}
                  className="w-full h-32 object-cover" data-testid={`foto-preview-${i}`} />
                {isEditing && (
                  <button type="button" onClick={() => handleFotoRemove(url)}
                    className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                    data-testid={`btn-remove-foto-${i}`}>
                    <X className="w-3 h-3" />
                  </button>
                )}
              </div>
            ))}
          </div>
        )}

        {pendingFiles.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-testid="pending-fotos-grid">
            {pendingFiles.map((p, i) => (
              <div key={p.preview} className="relative group rounded-lg overflow-hidden border border-blue-200 bg-blue-50">
                <img src={p.preview} alt={`Pendente ${i + 1}`} className="w-full h-32 object-cover" data-testid={`pending-foto-${i}`} />
                <button type="button" onClick={() => removePendingFile(i)}
                  className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                  data-testid={`btn-remove-pending-${i}`}>
                  <X className="w-3 h-3" />
                </button>
                <span className="absolute bottom-1 left-1 text-[10px] bg-blue-600 text-white px-1.5 py-0.5 rounded">Pendente</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
